module.exports = __webpack_public_path__ + "media/images/cover/street-view-449d203c06cfd4d90e0a404a30fa8a58.jpeg";